<script>
	import { capitalize } from "../tools.js";
	import { createEventDispatcher } from 'svelte';

	export let activeTab = -1;
	export let tabs = [];

	const dispatch = createEventDispatcher();

	function sendTab(n) {
	   activeTab = n;
	   dispatch('switch', {tab: activeTab});
	}
</script>

<div id="tabs" class="tab-group" role="tablist">
	{#each tabs as tab (tab.id)}
		<button role="tab" class="tab-item"
						class:active={tab.id === activeTab}
						on:click={() => (sendTab(tab.id))}
				>
			{#if tab.img}
				<img src="{tab.img}" alt="{tab.label}" title="{tab.label}" />
			{/if}
			<span>{capitalize(tab.label)}</span>
		</button>
	{/each}
</div>

<style>
	div.tab-group {
		height: 3rem;
		width: 100%;
		display: flex;
		align-items: flex-end;
		background-color: #c0c0c0;
		border-bottom: 2px solid #f0f0f0;
	}

	button.tab-item {
		cursor: pointer;
		position: relative;
		display: grid;
		place-items: center;
		margin: 0;
		flex-basis: 100%;
		border: none;
		background-color: rgb(240, 240, 240, 0);
		border-radius: 2px 2px 0 0;
		opacity: 0.5;
		transition: all ease 0.2s;
		height: 2.5rem;
	}

	button.tab-item:hover,
	button.tab-item:focus {
		opacity: 0.75;
		background-color: rgb(240, 240, 240, 0.75);
	}

	button.tab-item:active,
	button.tab-item.active {
		opacity: 1;
		background-color: rgb(240, 240, 240, 1);
	}

	button.tab-item span {
		position: absolute;
		width: 0;
		height: 0;
		overflow: hidden;
		opacity: 0;
	}

	button img {
		filter: none;
		margin: 0;
	}
</style>
